if (!customElements.get("custom-swiper")) {
  customElements.define(
    "custom-swiper",
    class CustomSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperContainer = this.querySelector("[data-swiper-container]");
        if (this.dataset.config) {
          this.config = JSON.parse(this.dataset.config);
        }

        this.swiper = null;
        this.prev = this.querySelector("[data-swiper-prev-button]");
        this.next = this.querySelector("[data-swiper-next-button]");
        this.scrollbar = this.querySelector("[data-scrollbar]");
        this.isPauseOnMounseenter = this.hasAttribute(
          "data-pause-onmouseenter"
        );
        this.pagination = this.querySelector("[data-pagination]");
        console.log("this.config", this.config);

        const config = {
          ...this.config,
        };
        if (this.prev && this.next) {
          config.navigation = {
            prevEl: this.prev,
            nextEl: this.next,
          };
        }
        if (this.scrollbar) {
          config.scrollbar = {
            el: this.scrollbar,
          };
        }
        if (this.pagination) {
          config.pagination = {
            el: this.pagination,
          };
        }
        console.log("config", config);
        this.swiper = new Swiper(this.swiperContainer, config);
        if (this.isPauseOnMounseenter) {
          // 鼠标放在上面暂停，未完成
          this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
          this.addEventListener("mouseleave", this.onMouseOut.bind(this));
        }
        this.addEventListener("swipeTo", (e) => {
          this.swipeTo.bind(this, e.detail.index)();
        });
      }
      swipeTo(index) {
  
        if (this.swiper) {
          this.swiper.slideTo(index);
        }
      }
      onMouseEnter() {
        console.log("mouse enter");
        // this.swiper.autoplay.stop();
      }
      onMouseOut() {
        console.log("mouse out");
        // this.swiper.autoplay.start();
      }
      connectedCallback() {}
    }
  );
}
